import axios from 'axios'
import { ElMessage } from 'element-plus'
import { API_CONFIG } from './config'
import store from '@/store'
import router from '@/router'
import i18n from '@/i18n'

// 创建axios实例
const service = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.HEADERS
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加token到请求头
    const token = store.getters['user/token']
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
      console.log('请求携带token:', token)
    }
    
    // 注释掉时间戳参数，因为后端不需要
    // if (config.method === 'get') {
    //   config.params = {
    //     ...config.params,
    //     _t: Date.now()
    //   }
    // }
    
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('API响应:', res)
    
    // 如果返回的状态码为0，说明接口请求成功
    if (res.code === 0) {
      return res
    } else if (res.code === 10001) {
      const msg = i18n.global.t('message.deviceOffline')
      ElMessage.error(msg)
      return Promise.reject(new Error(msg))
    } else {
      const fallback = i18n.global.t('message.requestFailed')
      ElMessage.error(res.msg || fallback)
      return Promise.reject(new Error(res.msg || fallback))
    }
  },
  error => {
    console.error('响应错误:', error)
    
    // 处理HTTP错误状态码
    if (error.response) {
      const { status } = error.response
      
      switch (status) {
        case 401:
          ElMessage.error(i18n.global.t('message.loginExpired'))
          store.dispatch('user/logout').then(() => {
            router.push('/login')
          })
          break
        case 403:
          ElMessage.error(i18n.global.t('message.noPermission'))
          break
        case 404:
          ElMessage.error(i18n.global.t('message.resourceNotFound'))
          break
        case 500:
          ElMessage.error(i18n.global.t('message.serverError'))
          break
        default:
          ElMessage.error(i18n.global.t('message.networkError'))
      }
    } else {
      ElMessage.error(i18n.global.t('message.networkConnectionFailed'))
    }
    
    return Promise.reject(error)
  }
)

export default service
